var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("threadController", [
    "$scope",
    "threadService",
    "$window",
    "$filter",
    "$rootScope",
    "productService",
    "modalService",
    "loaderService",
    "validationService",
    function (
        $scope,
        threadService,
        $window,
        $filter,
        $rootscope,
        productService,
        modalService,
        loaderService,
        validationService
    ) {
        //#region Thread Detail Variables
        $scope.threadBaseUrl = window.__env.threadImgBaseUrl.toLowerCase();
        $scope.SwatchImagePath = $scope.threadBaseUrl + "ThreadSwatch_Images/";
        $scope.spoolImagePath = $scope.threadBaseUrl + "ThreadSpool_Images/";
        $scope.infoloaded = false;
        $scope.showFreeShipFAQ = false;
        $scope.successNotifyInsert = null;
        //#endregion

        //#region Thread Detail page functions
        //#region Thread Detail Initialize
        $scope.getThreadInfo = function (prdMfg, prdcode) {
            loaderService.show();
            threadService
                .getThreadDetailsById(prdMfg, prdcode)
                .then(function (response) {
                    if (response) {
                        $scope.threadinfo = response.data;
                        $scope.threadVariants = $filter("orderBy")(
                            $scope.threadinfo.variants, "variantId"
                        );
                        loaderService.hide();
                     }
                    var variantId = _.map($window.products, function (product) {
                        return product.currentVariant;
                    })[0];
                    if (!angular.isUndefined($scope.threadVariants)) {
                        if (
                            angular.isUndefined(variantId) || variantId == "" || +variantId == 0
                        ) {
                            $scope.activeProductVariant = $scope.threadVariants[0];
                        } else {
                            if (variantId > $scope.threadVariants.length) {
                                $scope.activeProductVariant = $scope.threadVariants[0];
                            } else {
                                $scope.activeProductVariant =
                                    $scope.threadVariants.filter(function (m) {
                                        return m.variantId == +variantId;
                                    })[0];
                            }
                        }
                    }
                    productService.isfreeShippable(prdcode).then(function (r) {
                        $scope.isFreeShippableObj = r.data;
                    });
                    getReviews($scope.threadinfo.itemId);
                });
        };
        //#endregion

        //#region On click of Variants
        $scope.PreviewThread = function (variantid) {
            $scope.activeProductVariant = $scope.threadVariants.filter(
                function (m) {
                    return m.variantId == +variantid;
                }
            )[0];
            if ($rootscope.items && $rootscope.items.length > 0) {
                $scope.tempitems = $rootscope.items.filter(function (m) {
                    return (
                        m.productId ==
                        $scope.activeProductVariant.itemId.toLowerCase()
                    );
                })[0];
                if ($scope.tempitems) {
                    $scope.quantity = $scope.tempitems.quantity.toString();
                    document.getElementById("thread-quantity").disabled = true;
                } else {
                    document.getElementById("thread-quantity").disabled = false;
                    $scope.quantity = "1";
                }
            } else {
                document.getElementById("thread-quantity").disabled = false;
                $scope.quantity = "1";
            }
            if ($rootscope.appModalOpen == true) {
                modalService.close("mdlthreadVariants");
                $rootscope.appModalOpen = false;
            }

            $scope.successNotifyInsert = null;
        };
        //#endregion
        //#region Modal func for lower resolution

        $scope.clearFilter = function () {
            $scope.searchText = "";
        };
        //#endregion

        //#region Checkout and addtocart Helper Func

        $scope.$watch("$root.items", function () {
            if (angular.isDefined($scope.$root.items)) {
                if ($scope.$root.items.length > 0) {
                    if (angular.isDefined($scope.activeProductVariant.itemId)) {
                        $scope.tempitems = $scope.$root.items.filter(function (
                            m
                        ) {
                            return (
                                m.productId ==
                                $scope.activeProductVariant.itemId.toLowerCase()
                            );
                        })[0];
                    }

                    if ($scope.tempitems) {
                        $scope.quantity = $scope.tempitems.quantity.toString();
                        document.getElementById(
                            "thread-quantity"
                        ).disabled = true;
                    } else {
                        document.getElementById(
                            "thread-quantity"
                        ).disabled = false;
                        $scope.quantity = "1";
                    }
                }
            } else {
                if (document.getElementById("thread-quantity") != null) {
                    document.getElementById("thread-quantity").disabled = false;
                    $scope.quantity = "1";
                }
            }
        });
        //#endregion

        //#region Thread Reviews
        function getReviews(productId) {
            if (
                angular.isDefined(productId) &&
                productId != null &&
                productId != ""
            ) {
                productService
                    .getReviewsByProductId(productId)
                    .then(function (response) {
                        $scope.reviews = response.data;
                        var sum = 0;
                        $scope.reviewsCount = $scope.reviews.length;
                        if ($scope.reviews.length > 0) {
                            angular.forEach(
                                $scope.reviews,
                                function (value, key) {
                                    sum += parseFloat(value.rating);
                                }
                            );
                            var avg = sum / $scope.reviews.length;
                            $scope.avgRating = parseFloat(avg);
                        } else {
                            $scope.avgRating = 0;
                        }
                    });
            }
        }
        //#endregion
        //#endregion

        //#region Modals
        $scope.showThreadVariants = function () {
            $rootscope.appModalOpen = true;
            $scope.toggleModal("mdlthreadVariants", true);
        };
        $scope.showFreeShipping = function () {
            $scope.toggleModal("mdlFreeShipping", true);
        };
        //#endregion

        $scope.notifyme = function (prodId, catalogId) {
            $scope.validEmail = true;
            document.getElementById("emailNotify").style.border = "1px solid black";

            var email = document.getElementById("emailNotify").value;
            if (validationService.getRegularExpressions().email.test(email)) {
                $scope.queue = {};
                $scope.queue.FK_ItemId = $scope.activeProductVariant.itemId;
                $scope.queue.FK_CatalogId = catalogId;
                $scope.queue.EmailAddress = email;

                $scope.enteredEmail = email;
                modalService.open("confirmNotifyModal");
            } else {
                $scope.validEmail = false;
                document.getElementById("emailNotify").style.border = "1px solid red";
            }


        }

        $scope.submitNotify = function () {
            document.getElementById("emailNotify").style.border = "1px solid black";

            var email = document.getElementById("emailNotify").value;
            productService.insertNotifyInStock($scope.queue).then(function (response) {
                $scope.enteredEmail = email;
                $scope.successNotifyInsert = response.data;
                modalService.close("confirmNotifyModal");
            });
        }
    },
]);
